export default "__VITE_ASSET___ksUEwEB__"